import {SortingState} from "@tanstack/react-table";
import {Filters} from "@/features/types/AutoTableFilterInterface";
import {AutoTableInterface} from "@/features/types/AutoTableInterface";

export interface AutoTableStaticColumns {
    expand: unknown;
    details: unknown;
    actions: unknown;
}

export const staticColumns: Record<
    keyof AutoTableStaticColumns,
    { size: number; visibility: boolean; order: number }
> = {
    expand: {size: 60, visibility: true, order: 0},
    details: {size: 60, visibility: true, order: 1},
    actions: {size: 60, visibility: true, order: 2},
};

export const defaultPresetColumnsList: Array<keyof AutoTableInterface> =
    [
        "f_vis_mark_7",
        "f_loc_lit",
        "f_supp_2_doc_invc_o_diff",
        "f_vin",
        "f_ord_num",
        "f_ord_d",
        "f_prd_year",
        "f_veh_make",
        "f_veh_desc_1",
        "f_svo_code_4",
        "f_svo_code_6",
        "f_svo_code_8",
        "f_supp_2_status_desc",
        "f_sales_dat",
        "f_sales_user_name",
    ];

export interface PresetValue {
    filters: Filters;
    sorting: SortingState;
    config: {
        isDefault: boolean;
        columns: {
            [key: string]: { visibility: boolean; sizing: number; order: number };
        };
    };
}

export interface PresetStorage {
    presets: Record<string, PresetValue>;
    default?: string | null;
}

